import { useTranslation } from "react-i18next";

export default function FinalCtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A modern luxury residential building exterior at golden hour with warm sunlight, contemporary architecture with clean lines and large windows, green landscaping around the property, warm cream and champagne gold color tones, inviting and aspirational atmosphere, architectural photography style, no people, high-end real estate"
          alt="理想住宅展望"
          className="w-full h-full object-cover object-center"
          width="1920"
          height="600"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/50 to-black/55" />
      </div>

      <div className="relative z-10 container-main px-4 md:px-8 lg:px-12 text-center">
        <span className="inline-block px-4 py-1.5 bg-champagne/20 backdrop-blur-sm text-champagne text-base md:text-base font-semibold tracking-wider rounded-full mb-5">
          {t("process.final.label")}
        </span>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-cream mb-4 max-w-3xl mx-auto">
          {t("process.final.title")}
        </h2>
        <p className="text-base md:text-base text-cream/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          {t("process.final.desc")}
        </p>
        <a
          href="https://lin.ee/OpssTIM"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-7 py-3.5 bg-champagne text-graphite rounded-full text-base font-semibold transition-all duration-300 hover:bg-champagne/90 hover:-translate-y-0.5 whitespace-nowrap"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-line-fill" />
          </span>
          {t("process.final.cta")}
        </a>
      </div>
    </section>
  );
}